import { useActivation } from '@context/MobileOne';
import { Feedback, ScrollToTop } from '@core/index';
import { appButtonType, appIconsPath } from '@utils/globalConstant';
import { tA11y } from '@utils/a11y/a11yHelpers';

export const EmailVerificationResendSuccess = () => {
  const { setStep0SubStep } = useActivation();

  // Const
  const headerContent = tA11y('ek_reg_rsnd_hdl1');
  const copyTextContent = tA11y('ek_reg_rsnd_txt1');
  const buttonContent = tA11y('ek_reg_rsnd_btn1');

  return (
    <>
      <ScrollToTop>
        <Feedback
          icon='SENT'
          headingContent={headerContent}
          copyTextContent={copyTextContent}
          buttonContent={buttonContent}
          buttonType={appButtonType.PRIMARY}
          buttonIcon={appIconsPath.ARROW_RIGHT}
          buttonClick={() => setStep0SubStep(2)}
        />
      </ScrollToTop>
    </>
  );
};

export default EmailVerificationResendSuccess;
